<template>
  <div class="medicines-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="medicines-container">
      <!-- Header Section -->
      <div class="medicines-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-capsules title-icon"></i>
              Medicamentos
            </h1>
            <p class="page-subtitle">
              Gerencie o catálogo de medicamentos da instituição
            </p>
          </div>

          <div class="actions-section">
            <v-btn
              v-if="$route.query.migrar_boxifarma_sistemaclin"
              class="btn-add-modern mr-2"
              @click="boxifarma"
            >
              <i class="fas fa-plus mr-2"></i>
              Sincronizar medicamentos BOXIFARMA com SistemaClin
            </v-btn>

            <v-btn
              v-if="permission('write', 'medicine')"
              class="btn-add-modern"
              @click="handleModalCreate"
            >
              <i class="fas fa-plus mr-2"></i>
              Adicionar
            </v-btn>

            <v-btn
              v-if="user_id == '2844'"
              class="btn-add-modern"
              @click="handleModalCreateActiveIngredient"
            >
              <i class="fas fa-plus mr-2"></i>
              Adicionar Princípio Ativo
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="medicines-content">
        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-card">
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-search filter-icon"></i>
                Pesquisar medicamentos
              </label>
              <v-text-field
                v-model="search"
                placeholder="Digite o nome ou princípio ativo"
                outlined
                dense
                hide-details
                class="modern-input"
                @input="handleChangeSearch"
              />
            </div>
          </div>
        </div>

        <!-- Data Table Section -->
        <div class="table-section">
          <div class="table-card">
            <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
              <v-data-table
                :headers="headers"
                :items="medicines"
                item-key="`${type}`/${id}"
                :footer-props="{
                  'items-per-page-options': [100, 175, 200],
                  'items-per-page-text': 'Mostrar',
                }"
                :options.sync="options"
                :server-items-length="total"
                class="modern-table"
                :no-data-text="'Nenhum medicamento encontrado'"
                :loading-text="'Carregando medicamentos...'"
              >
                <template
                  v-slot:[`item.standard_medicine_associates`]="{ item }"
                >
                  <div v-if="item.standard_medicine_associates.length > 0">
                    <ul>
                      <li
                        v-for="standard_medicine_associate in item.standard_medicine_associates"
                        :key="`${standard_medicine_associate.id}-${item.id}`"
                        v-show="standard_medicine_associate.medicamento"
                      >
                        <small class="badge badge-light">
                          {{
                            JSON.parse(standard_medicine_associate.medicamento)
                              .produto
                          }}</small
                        >
                      </li>
                    </ul>
                  </div>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div class="d-flex align-items-center">
                    <v-btn
                      v-if="
                        (rest_home_id == 1 && $route.query.atualizar) ||
                        user_id == 2844
                      "
                      class="m-1 btn-modern btn-modern-add"
                      small
                      @click="handleToAssociate(item)"
                    >
                      <i class="fas fa-exchange-alt mr-1"></i>
                      Associar
                    </v-btn>
                    <div class="medicine-name-cell">
                      <v-tooltip bottom max-width="600">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on" class="medicine-name">
                            {{ item.name }}
                          </div>
                        </template>
                        <span>{{ item.name }}</span>
                      </v-tooltip>
                    </div>
                  </div>

                  <b-modal
                    no-close-on-backdrop
                    size="xl"
                    :id="`associate-${item.id}`"
                    hide-footer
                    scrollable
                  >
                    <template v-slot:modal-title>
                      <div class="modal-title-modern">{{ item.name }}</div>
                    </template>

                    <div class="modal-content-modern">
                      <div>
                        <ErrorsMessages :errors="errors" />
                      </div>
                      <p class="m-0">
                        <strong>Nome comercial:</strong> {{ item.name }}
                      </p>
                      <p class="m-0">
                        <strong>Princípio ativo:</strong>
                        {{ item.active_ingredient }}
                      </p>
                      <p class="m-0">
                        <strong>Apresentação:</strong> {{ item.presentation }}
                      </p>
                      <p class="m-0">
                        <strong>Classe terapêutica:</strong>
                        {{ item.therapeutic_class }}
                      </p>
                      <p class="m-0">
                        <strong>Unidade de medida:</strong>
                        {{ item.unit_of_measurement_name }}
                      </p>

                      <div>
                        <div class="filters-section">
                          <div class="">
                            <v-text-field
                              v-model="searchToAssociate"
                              placeholder="Digite o nome"
                              outlined
                              dense
                              hide-details
                              class="modern-input"
                              @input="paginateToAssociate"
                            />
                            <v-text-field
                              v-model="searchToAssociateprincipio_ativo"
                              placeholder="Digite o princípio ativo"
                              outlined
                              dense
                              hide-details
                              class="modern-input"
                              @input="paginateToAssociate"
                            />
                            <v-text-field
                              v-model="searchToAssociatecodigo_barras"
                              placeholder="Digite o código de barras"
                              outlined
                              dense
                              hide-details
                              class="modern-input"
                              @input="paginateToAssociate"
                            />
                          </div>
                        </div>

                        <!-- Data Table Section -->
                        <div class="table-section">
                          <div class="table-card">
                            <b-overlay
                              :show="loadingToAssociate"
                              opacity="0.99"
                              class="loading-overlay"
                            >
                              <v-data-table
                                :headers="headersToAssociate"
                                :items="medicinesToAssociate"
                                item-key="`${type}`/${id}/to-associate"
                                :footer-props="{
                                  'items-per-page-options': [100],
                                  'items-per-page-text': 'Mostrar',
                                }"
                                :options.sync="optionsToAssociate"
                                :server-items-length="totalToAssociate"
                                class="modern-table"
                                :no-data-text="'Nenhum medicamento encontrado'"
                                :loading-text="'Carregando medicamentos...'"
                              >
                                <template v-slot:[`item.select`]="{ item }">
                                  <input
                                    type="checkbox"
                                    :value="item"
                                    v-model="selectedMedicineToAssociates"
                                    style="
                                      cursor: pointer;
                                      width: 16px;
                                      height: 16px;
                                    "
                                  />
                                </template>
                              </v-data-table>
                            </b-overlay>
                          </div>
                        </div>
                      </div>

                      <div class="text-right">
                        <small
                          v-if="selectedMedicineToAssociates.length > 0"
                          class="text-muted mr-3"
                        >
                          Selecione um medicamento da BOXI para associar com o
                          do SISTEMACLIN
                        </small>

                        <v-btn
                          v-if="selectedMedicineToAssociates.length > 0"
                          class="btn-modern btn-modern-add"
                          @click="associateMedicine(item.id)"
                          >Associar</v-btn
                        >
                      </div>
                    </div>
                  </b-modal>
                </template>

                <template v-slot:[`item.active_ingredient`]="{ item }">
                  <div class="ingredient-cell">
                    <v-tooltip bottom max-width="600">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="ingredient-name">
                          {{ item.active_ingredient }}
                        </div>
                      </template>
                      <span>{{ item.active_ingredient }}</span>
                    </v-tooltip>
                  </div>
                </template>

                <template v-slot:[`item.type`]="{ item }">
                  <span
                    class="type-badge"
                    :class="
                      item.type === 'PADRAO' ? 'type-standard' : 'type-company'
                    "
                  >
                    {{ item.type === "PADRAO" ? "PADRÃO" : "EMPRESA" }}
                  </span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    class="btn-modern btn-modern-info"
                    small
                    @click="handleToMedicine(item)"
                  >
                    <i class="fas fa-edit mr-1"></i>
                    Editar
                  </v-btn>

                  <v-btn
                    v-if="
                      (rest_home_id == 1 && $route.query.atualizar) ||
                      user_id == 2844
                    "
                    class="m-1 btn-modern btn-modern-delete"
                    small
                    @click="handleToDelete(item)"
                  >
                    <i class="fas fa-times mr-1"></i>
                    Excluir
                  </v-btn>

                  <b-modal
                    no-close-on-backdrop
                    size="xl"
                    :id="`delete-${item.id}`"
                    hide-footer
                    scrollable
                  >
                    <template v-slot:modal-title>
                      <div class="modal-title-modern">{{ item.name }}</div>
                    </template>

                    <div class="modal-content-modern">
                      <div>
                        <ErrorsMessages :errors="errors" />
                      </div>
                      <p class="m-0">
                        <strong>Nome comercial:</strong> {{ item.name }}
                      </p>
                      <p class="m-0">
                        <strong>Princípio ativo:</strong>
                        {{ item.active_ingredient }}
                      </p>
                      <p class="m-0">
                        <strong>Apresentação:</strong> {{ item.presentation }}
                      </p>
                      <p class="m-0">
                        <strong>Classe terapêutica:</strong>
                        {{ item.therapeutic_class }}
                      </p>
                      <p class="m-0">
                        <strong>Unidade de medida:</strong>
                        {{ item.unit_of_measurement_name }}
                      </p>

                      <div>
                        <div class="filters-section">
                          <div class="filter-group">
                            <v-text-field
                              v-model="searchToDelete"
                              placeholder="Digite o nome ou princípio ativo"
                              outlined
                              dense
                              hide-details
                              class="modern-input"
                              @input="handleChangeSearchToDelete"
                            />
                          </div>
                        </div>

                        <!-- Data Table Section -->
                        <div class="table-section">
                          <div class="table-card">
                            <b-overlay
                              :show="loadingToDelete"
                              opacity="0.99"
                              class="loading-overlay"
                            >
                              <v-data-table
                                :headers="headersToDelete"
                                :items="medicinesToDelete"
                                item-key="`${type}`/${id}/to-delete"
                                :footer-props="{
                                  'items-per-page-options': [10, 25],
                                  'items-per-page-text': 'Mostrar',
                                }"
                                :options.sync="optionsToDelete"
                                :server-items-length="totalToDelete"
                                class="modern-table"
                                :no-data-text="'Nenhum medicamento encontrado'"
                                :loading-text="'Carregando medicamentos...'"
                              >
                                <template v-slot:[`item.select`]="{ item }">
                                  <input
                                    type="radio"
                                    :value="item"
                                    v-model="selectedMedicineToReplace"
                                    style="
                                      cursor: pointer;
                                      width: 16px;
                                      height: 16px;
                                    "
                                  />
                                </template>

                                <template v-slot:[`item.type`]="{ item }">
                                  <span
                                    class="type-badge"
                                    :class="
                                      item.type === 'PADRAO'
                                        ? 'type-standard'
                                        : 'type-company'
                                    "
                                  >
                                    {{
                                      item.type === "PADRAO"
                                        ? "PADRÃO"
                                        : "EMPRESA"
                                    }}
                                  </span>
                                </template>
                              </v-data-table>
                            </b-overlay>
                          </div>
                        </div>
                      </div>

                      <div class="text-right">
                        <small
                          v-if="!selectedMedicineToReplace"
                          class="text-muted mr-3"
                        >
                          Selecione um medicamento substituto ou exclua sem
                          substituição
                        </small>

                        <v-btn
                          class="btn-modern btn-modern-delete"
                          @click="deleteMedicine(item.id)"
                          >Excluir</v-btn
                        >
                      </div>
                    </div>
                  </b-modal>
                </template>
              </v-data-table>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Create -->
    <b-modal
      no-close-on-backdrop
      size="xl"
      id="createMedicine"
      hide-footer
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-capsules mr-2"></i>
          Novo Medicamento
        </div>
      </template>

      <div class="modal-content-modern">
        <form @submit="create" method="post">
          <div class="form-grid">
            <!-- Nome Comercial -->
            <div class="form-group full-width">
              <LabelRequiredField label="Nome Comercial" />
              <input
                type="text"
                ref="autofocus"
                v-model="name"
                class="modern-form-input"
                placeholder="Digite o nome comercial do medicamento"
              />
            </div>

            <!-- Princípio Ativo -->
            <div class="form-group full-width">
              <SelectActiveIngredientID
                v-model="active_ingredient_id"
                class="modern-select"
              />
            </div>

            <!-- Lista -->
            <div class="form-group">
              <label class="form-label">Lista</label>
              <select v-model="list" class="modern-form-select">
                <option value="">Selecione...</option>
                <option
                  v-for="value in lists"
                  :key="value.id"
                  :value="value.name"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>

            <!-- Tipo de Receita -->
            <div class="form-group">
              <label class="form-label">Tipo de Receita</label>
              <select v-model="type_of_recipe_id" class="modern-form-select">
                <option value="">Selecione...</option>
                <option
                  v-for="value in typesOfRecipe"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>

            <!-- Unidade de Medida -->
            <div class="form-group">
              <LabelRequiredField label="Unidade de Medida" />
              <select
                v-model="unit_of_measurement_id"
                class="modern-form-select"
              >
                <option value="">Selecione...</option>
                <option
                  v-for="value in unitOfMeasurements"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ value.name }}
                </option>
              </select>
            </div>

            <!-- Classe Terapêutica -->
            <div class="form-group">
              <label class="form-label">Classe Terapêutica</label>
              <input
                type="text"
                v-model="therapeutic_class"
                class="modern-form-input"
                placeholder="Digite a classe terapêutica"
              />
            </div>

            <!-- Tipo de Medicamento -->
            <div class="form-group">
              <label class="form-label">Tipo de Medicamento</label>
              <select v-model="type_of_medicine_id" class="modern-form-select">
                <option value="">Selecione...</option>
                <option
                  v-for="value in typesOfMedicine"
                  :key="value.id"
                  :value="value.id"
                >
                  {{ String(value.name).toUpperCase() }}
                </option>
              </select>
            </div>

            <!-- Custo do Medicamento -->
            <div class="form-group">
              <label class="form-label">Custo do Medicamento</label>
              <input
                type="text"
                v-model="medicine_cost"
                class="modern-form-input"
                placeholder="R$ 0,00"
                @keyup="handleValueMedicineCost"
              />
            </div>

            <!-- Lucro -->
            <div class="form-group">
              <label class="form-label">Lucro (%)</label>
              <input
                type="text"
                v-model="profit"
                class="modern-form-input"
                placeholder="0,00%"
                @keyup="handleValueProfit"
              />
            </div>

            <!-- Valor da Venda -->
            <div class="form-group">
              <label class="form-label">Valor da Venda</label>
              <input
                type="text"
                v-model="sale_price"
                class="modern-form-input"
                placeholder="R$ 0,00"
                @keyup="handleValueSalePrice"
              />
            </div>
          </div>

          <!-- Warning and Errors -->
          <div class="form-footer">
            <WarningRequiredFields />
            <ErrorsMessages :errors="errors" />

            <div class="form-actions">
              <v-btn
                :disabled="loadingCreate"
                type="submit"
                class="btn-save-modern"
              >
                <i class="fas fa-save mr-2"></i>
                {{ loadingCreate ? "Salvando..." : "Salvar Medicamento" }}
              </v-btn>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal
      no-close-on-backdrop
      size="xl"
      id="boxifarma"
      hide-footer
      scrollable
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          Sincronizar medicamentos BOXIFARMA com SistemaClin
        </div>
      </template>

      <div class="modal-content-modern">
        <div>
          <ErrorsMessages :errors="errors" />
        </div>
        <div>
          <div>
            <v-text-field
              v-model="searchBoxis"
              prepend-inner-icon="mdi-magnify"
              placeholder="PESQUISAR"
              outlined
              dense
              hide-details
              @input="boxifarma"
            />
          </div>
          <v-data-table
            dense
            :headers="headersBoxis"
            :items="boxis"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            :options.sync="optionsBoxis"
            :server-items-length="totalBoxis"
            class="modern-table"
            :no-data-text="'Nenhum medicamento encontrado'"
            :loading-text="'Carregando medicamentos...'"
          >
            <template v-slot:[`item.medicamento`]="{ item }">
              {{ item.medicamento }}
            </template>
          </v-data-table>
        </div>
      </div>
    </b-modal>

    <b-modal id="active_ingredient_name" hide-footer no-close-on-backdrop>
      <template v-slot:modal-title>NOVO PRINCÍPIO ATIVO</template>
      <div class="d-block">
        <div class="container">
          <form v-on:submit="createActiveIngredient" method="post">
            <div class="row">
              <WarningRequiredFields />
              <ErrorsMessages :errors="errors" />
              <div class="col-md-12">
                <LabelRequiredField label="Nome" />
                <input
                  type="text"
                  v-model="active_ingredient_name"
                  class="form-control"
                />
              </div>
              <div class="col-md-12 text-right">
                <v-btn
                  :disabled="loadingCreate"
                  type="submit"
                  class="v-success"
                >
                  <span class="mr-2 fa fa-check"></span>
                  {{ loadingCreate ? "Carregando" : "Salvar" }}
                </v-btn>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import LabelRequiredField from "../templates/Components/LabelRequiredField";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import SelectActiveIngredientID from "../templates/Components/SelectActiveIngredientID";

import api from "../services/api";
import routes from "../routes";
import toast from "../lib/ToastNotification";
import permission from "../lib/permission";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
  formatDate,
} from "../lib/format";

import { userData } from "../lib/functions";

export default {
  name: "Medicines",
  components: {
    NavBar,
    AuthBySessionExpired,
    SelectActiveIngredientID,
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },
  data() {
    return {
      user_id: null,
      pageToAssociate: 1,
      medicinesToAssociate: [],
      selectedMedicineToAssociates: [],
      headersToAssociate: [
        { text: "", value: "select", sortable: false },
        { text: "NOME", value: "produto", sortable: false },
        { text: "PRINCÍPIO ATIVO", value: "principio_ativo", sortable: false },
        { text: "UND/M", value: "forma", sortable: false },
        { text: "CÓD. BARRAS", value: "codigo_barras", sortable: false },
        { text: "NCM", value: "ncm", sortable: false },
      ],
      totalToAssociate: 0,
      optionsToAssociate: {},
      searchToAssociate: "",
      searchToAssociateprincipio_ativo: "",
      searchToAssociatecodigo_barras: "",
      atualizar: false,
      selectedMedicineToReplace: null,
      searchToDelete: "",
      pageToDelete: 1,
      medicinesToDelete: [],
      headersToDelete: [
        { text: "", value: "select", sortable: false },
        { text: "NOME COMERCIAL", value: "name" },
        { text: "PRINCÍPIO ATIVO", value: "active_ingredient" },
        { text: "UND/M", value: "unit_of_measurement_name" },
        { text: "APRE.", value: "presentation" },
        { text: "CLAS. TERA.", value: "therapeutic_class" },
      ],
      totalToDelete: 0,
      optionsToDelete: {},
      searchBoxis: "",
      pageBoxis: 1,
      boxis: [],
      headersBoxis: [
        { text: "medicamento", value: "medicamento" },
        { text: "principio_ativo", value: "principio_ativo" },
        { text: "tipo_medicamento", value: "tipo_medicamento" },
        { text: "forma", value: "forma" },
        { text: "tipo_receita", value: "tipo_receita" },
      ],
      totalBoxis: 0,
      optionsBoxis: {},

      total: 0,
      options: {},
      search: "",
      headers: [
        { text: "NOME COMERCIAL", value: "name" },
        { text: "PRINCÍPIO ATIVO", value: "active_ingredient" },
        // { text: "TIPO", value: "type" },
        { text: "AÇÕES", value: "actions", sortable: false },
      ],
      rest_home_id: "",
      lists: [
        { id: 1, name: "A1" },
        { id: 2, name: "A2" },
        { id: 3, name: "A3" },
        { id: 4, name: "B1" },
        { id: 5, name: "C1" },
        { id: 6, name: "C5" },
        { id: 7, name: "D1" },
      ],
      medicines: [],
      unitOfMeasurements: [],
      typesOfMedicine: [],
      typesOfRecipe: [],
      unit_of_measurement_id: "",
      type_of_medicine_id: "",
      type_of_recipe_id: "",
      medicine: {},
      active_ingredient_name: "",
      id: "",
      name: "",
      therapeutic_class: "",
      active_ingredient: [],
      active_ingredient_id: "",
      list: "",
      medicine_cost: "",
      profit: "",
      sale_price: "",
      loading: false,
      loadingToAssociate: false,
      loadingToDelete: false,
      loadingCreate: false,
      errors: [],

      usuario_medicamento: null,
    };
  },
  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
    optionsToAssociate: {
      handler() {
        this.paginateToAssociate();
      },
    },
    optionsToDelete: {
      handler() {
        this.paginateToDelete();
      },
    },
    optionsBoxis: {
      handler() {
        this.boxifarma();
      },
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    formatPrice,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,
    formatDate,
    handleChangeSearch() {
      this.options.page = 1;
      this.paginate();
    },
    handleChangeSearchToDelete() {
      this.optionsToDelete.page = 1;
      this.paginateToDelete();
    },
    handleToBack: () => routes.go(-1),
    handleToMedicine({ id }) {
      routes.push({ name: "medicine", params: { id } });
    },
    handleToAssociate({ id, name }) {
      this.searchToAssociate = name;
      this.selectedMedicineToAssociates = [];
      this.$bvModal.show(`associate-${id}`);
    },
    handleToDelete({ id }) {
      this.searchToDelete = this.search;
      // this.medicinesToDelete = [];
      this.selectedMedicineToReplace = null;
      this.$bvModal.show(`delete-${id}`);
      // this.paginateToDelete();
    },
    handleValueProfit: function (e) {
      var profit = formatValueToPercentage(e.target.value);
      if (profit) {
        var current = formatValueToOnlyNumber(this.medicine_cost);
        var percentage = profit * current;
        var sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },
    handleValueMedicineCost: function (e) {
      this.medicine_cost = formatValueOnKeyUp(e.target.value);

      var current = formatValueToOnlyNumber(e.target.value);
      var sale_price = formatValueToOnlyNumber(this.sale_price);

      if (parseInt(current) <= parseInt(sale_price)) {
        var percentage = parseFloat(sale_price - current);
        var profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = profit.replace(".", ",");
      }
    },
    handleValueSalePrice: function (e) {
      this.sale_price = formatValueOnKeyUp(e.target.value);

      var current = formatValueToOnlyNumber(this.medicine_cost);
      var sale_price = formatValueToOnlyNumber(e.target.value);

      if (parseInt(current) <= parseInt(sale_price)) {
        var percentage = parseFloat(sale_price - current);
        var profit = percentage * 100;
        profit = profit / current;
        profit = String(profit);
        this.profit = profit.replace(".", ",");
      }
    },
    async retrieve() {
      this.user_id = userData().user.id;
      this.rest_home_id = userData().user.rest_home_id;

      let { atualizar } = this.$router.currentRoute.query;

      if (atualizar && atualizar == "ok") {
        this.atualizar = "atualizar";
      }

      if (this.user_id == 2844) {
        this.usuario_medicamento = "usuario_medicamento";
        this.headers.unshift({
          text: "MEDICAMENTOS ASSOCIADOS",
          value: "standard_medicine_associates",
          sortable: false,
        });
      }

      if (this.errors.length == 0) await this.getUnitOfMeasurements();
      if (this.errors.length == 0) await this.getActiveIngredient();
      if (this.errors.length == 0) await this.getTypesOfMedicine();
      if (this.errors.length == 0) await this.getTypesOfRecipe();
    },
    async paginate() {
      try {
        this.loading = true;

        const { rest_home_id, search, atualizar } = this;
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        let params = {
          rest_home_id,
          page,
          itemsPerPage,
          search,
          sortBy,
          sortDesc,
          atualizar,
        };

        const response = await api.get("/rest-home/medicine/paginate", {
          params,
        });

        const { error, errors, medicines, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicines = medicines;
          this.total = total;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async paginateToDelete() {
      try {
        this.loadingToDelete = true;

        const { rest_home_id, searchToDelete: search } = this;
        const { page, itemsPerPage, sortBy, sortDesc } = this.optionsToDelete;

        let params = {
          rest_home_id,
          page,
          itemsPerPage,
          search,
          sortBy,
          sortDesc,
        };

        const response = await api.get(
          "/rest-home/medicine/paginate-to-delete",
          {
            params,
          }
        );

        const { error, errors, medicines, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicinesToDelete = medicines;
          this.totalToDelete = total;
        }
        this.loadingToDelete = false;
      } catch (error) {
        this.loadingToDelete = false;
        console.log(error);
      }
    },
    async getUnitOfMeasurements() {
      try {
        const response = await api.get("/rest-home/unit-of-measurement/all");
        const { error, errors, unit_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.unitOfMeasurements = unit_of_measurement;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getActiveIngredient() {
      try {
        const response = await api.get("/rest-home/active-ingredients");
        const { error, errors, active_ingredient } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.active_ingredient = active_ingredient;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTypesOfMedicine() {
      try {
        const response = await api.get("/rest-home/type-of-medicine/all");
        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfMedicine = types;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTypesOfRecipe() {
      try {
        const response = await api.get("/rest-home/type-of-recipe/all");
        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typesOfRecipe = types;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();
        this.loadingCreate = true;

        const {
          rest_home_id,
          unit_of_measurement_id,
          active_ingredient_id,
          type_of_medicine_id,
          type_of_recipe_id,
          name,
          therapeutic_class,
          list,
          medicine_cost,
          profit,
          sale_price,
          usuario_medicamento,
        } = this;

        let params = {
          rest_home_id,
          unit_of_measurement_id,
          active_ingredient_id,
          type_of_medicine_id,
          type_of_recipe_id,
          name,
          therapeutic_class,
          list,
          medicine_cost,
          profit,
          sale_price,
          usuario_medicamento,
        };

        const response = await api.post("/rest-home/medicine/create", params);
        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("createMedicine");
          this.paginate();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.unit_of_measurement_id = "";
      this.active_ingredient_id = "";
      this.type_of_medicine_id = "";
      this.type_of_recipe_id = "";
      this.name = "";
      this.therapeutic_class = "";
      this.medicine_cost = "";
      this.profit = "";
      this.sale_price = "";
      this.errors = [];
      this.$bvModal.show("createMedicine");
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },

    handleModalCreateActiveIngredient() {
      this.active_ingredient_name = "";
      this.errors = [];
      this.$bvModal.show("active_ingredient_name");
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },

    async deleteMedicine(id) {
      try {
        this.loading = true;

        let data = { id, new_id: this.selectedMedicineToReplace?.id ?? null };

        const response = await api.delete("/rest-home/medicine/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`delete-${id}`);
          this.selectedMedicineToReplace = null;
          this.paginate();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginateToAssociate() {
      try {
        this.loadingToAssociate = true;

        const {
          rest_home_id,
          searchToAssociate: search,
          searchToAssociateprincipio_ativo: principio_ativo,
          searchToAssociatecodigo_barras: codigo_barras,
        } = this;
        const { page, itemsPerPage, sortBy, sortDesc } =
          this.optionsToAssociate;

        let params = {
          rest_home_id,
          page,
          itemsPerPage,
          search,
          principio_ativo,
          codigo_barras,
          sortBy,
          sortDesc,
          method: "associate",
        };

        const response = await api.post(
          "/boxifarma/migrate",
          {},
          {
            params,
          }
        );

        if (response.data.retorno) {
          const {
            error,
            errors,
            data: medicines,
            total,
          } = response.data.retorno;

          if (error) {
            this.errors = errors;
          } else {
            this.errors = [];
            this.medicinesToAssociate = medicines;
            this.totalToAssociate = total;
          }
        } else {
          this.errors = [];
          this.medicinesToAssociate = [];
          this.totalToAssociate = 0;
        }

        this.loadingToAssociate = false;
      } catch (error) {
        this.loadingToAssociate = false;
        console.log(error);
      }
    },

    async associateMedicine(id) {
      try {
        this.loading = true;

        let { selectedMedicineToAssociates } = this;

        for (let item of selectedMedicineToAssociates) {
          let data = {
            id,
            medicamento_id: item.medicamento_id,
            medicamento: item,
          };

          const response = await api.post(
            "/rest-home/medicine/associate",
            data
          );

          const { error, errors } = response.data;

          if (error) {
            this.errors = errors;
          }
        }

        this.$bvModal.hide(`associate-${id}`);
        this.selectedMedicineToAssociates = [];
        this.paginate();
        toast("Medicamento associado com sucesso", "success");

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async boxifarma() {
      try {
        this.$bvModal.show("boxifarma");

        const { page, itemsPerPage: per_page } = this.optionsBoxis;

        let { searchBoxis: search } = this;

        const response = await api.post(
          "/boxifarma/migrate",
          {},
          {
            params: { page, per_page, search, method: "medicamento" },
          }
        );

        const { retorno } = response.data;

        if (retorno) {
          let { data, total } = retorno;
          this.boxis = data;
          this.totalBoxis = total;
        }
      } catch (error) {
        this.$bvModal.show("boxifarma");
        console.log(error);
      }
    },

    async createActiveIngredient(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { active_ingredient_name } = this;

        let params = { name: active_ingredient_name };

        const response = await api.post("/admin/active-ingredient", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("active_ingredient_name");
          this.retrieve();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.medicines-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.medicines-container {
  max-width: 95%;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.medicines-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

/* Content Section */
.medicines-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Filters Section */
.filters-section {
  margin-bottom: 8px;
}

.filters-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 400px;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.filter-icon {
  color: #6b7280;
  font-size: 14px;
}

/* Table Section */
.table-section {
  margin-bottom: 32px;
}

.table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.loading-overlay {
  border-radius: 16px;
}

/* Table Styling */
.modern-table {
  background: transparent !important;
}

.medicine-name-cell,
.ingredient-cell {
  max-width: 300px;
}

.medicine-name,
.ingredient-name {
  font-weight: 500;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;
}

.type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.type-standard {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
  border: 1px solid #60a5fa;
}

.type-company {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.btn-action-edit {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(29, 117, 190, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-action-edit:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(29, 117, 190, 0.4) !important;
}

/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.modern-form-input,
.modern-form-select {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  background: white !important;
}

.modern-form-input:focus,
.modern-form-select:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

.form-footer {
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
  margin-top: 24px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .medicines-container {
    padding: 0 16px;
  }

  .medicines-header {
    padding: 16px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .filters-card,
  .table-card {
    border-radius: 12px;
    padding: 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .modal-content-modern {
    padding: 0;
  }
}

@media (max-width: 480px) {
  .btn-add-modern {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }

  .page-title {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 14px;
  }
}

/* Override Vuetify styles */
.modern-input >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-input >>> .v-text-field__slot input {
  font-weight: 500 !important;
  padding: 12px 0 !important;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}
</style>